export const ArrowDropDown = () => (
  <svg width='10' height='5' viewBox='0 0 10 5' fill='inherit' xmlns='http://www.w3.org/2000/svg'>
    <path d='M0 0L5 5L10 0H0Z' fill='inherit' />
  </svg>
);

export const AppsBudgetDropDown = (props) => (
  <svg
    style={{ ...props?.style }}
    width='8'
    height='8'
    viewBox='0 0 8 8'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M4 2L8 6H0L4 2Z' fill='inherit' />
  </svg>
);
